import { Box, Button, TextareaProps } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { TextArea } from "./TextArea";

interface JsonTextAreaFieldProps {
  name: string;
  label: string;
  valueText: unknown | null;
  errors: string | undefined;
  horizontal?: boolean;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}

export const JsonTextAreaField = ({
  name,
  label,
  valueText,
  setFieldValue,
  errors,
  horizontal,
  ...props
}: JsonTextAreaFieldProps & TextareaProps) => {
  const view = useMemo(() => {
    return (
      <Box w="100%" position="relative">
        <Button
          size="xs"
          position="absolute"
          top={horizontal ? 2 : undefined}
          right={horizontal ? 6 : 4}
          zIndex="2"
          onClick={() => {
            if (!(valueText as string)) return;
            try {
              const jsonObject = JSON.parse(valueText as string);
              setFieldValue(name, JSON.stringify(jsonObject, null, 2));
            } catch {}
          }}
          disabled={errors != null}
          colorScheme="cherryButton"
        >
          Prettify
        </Button>
        <TextArea
          horizontal={horizontal}
          label={label}
          name={name}
          rows={20}
          fontSize="xs"
          {...props}
          fontFamily="jsonTextArea"
        />
      </Box>
    );
  }, [valueText, errors, props]);

  return <>{view}</>;
};
